import { Box, styled } from '@mui/material';

export const CourseCurriculumContentStyle = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 75px',
  gap: 16,
  padding: '6px 16px',

  '&:hover': {
    background: theme.palette.statePrimaryOverlay.hover,
  },
}));
